import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

interface UserProfile {
  name: string;
  email: string;
  role: string;
  createdAt: Date;
}

interface UserStats {
  totalOrders: number;
  activeOrders: number;
  completedOrders: number;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  user: UserProfile | null = null;
  stats: UserStats | null = null;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.loadUserProfile();
    this.loadUserStats();
  }

  loadUserProfile() {
    // Aquí irá la llamada al servicio para obtener los datos del usuario
    this.user = {
      name: 'Usuario Ejemplo',
      email: 'usuario@ejemplo.com',
      role: 'Usuario',
      createdAt: new Date()
    };
  }

  loadUserStats() {
    // Aquí irá la llamada al servicio para obtener las estadísticas
    this.stats = {
      totalOrders: 150,
      activeOrders: 45,
      completedOrders: 105
    };
  }

  editProfile() {
    // Implementar lógica para editar perfil
  }

  changePassword() {
    // Implementar lógica para cambiar contraseña
  }
} 